// extracted by mini-css-extract-plugin
export default {"container":"share_container__1i1TI","inner":"share_inner__2YZVT","action":"share_action__DB3Lm","image":"share_image__stFH1","share":"share_share__3wPFf"};